import PropTypes from 'prop-types';
import React from 'react';

const itemLabel = (item, labels, contactLabel) => {
  if (item.label) return item.label;
  if (item.key === 'marketing_crm') return contactLabel;
  return labels.items[item.key];
};

const NavPreview = ({ layout, registry, labels, contactLabel }) => (
  <div className="ntype-preview" data-testid="nav-preview">
    <div className="ntype-preview-group">Calendar</div>
    <div className="ntype-preview-group">{registry.locked.label}</div>
    {registry.locked.items.map((item) => <div key={item.key} className="ntype-preview-item">{item.label}</div>)}
    {layout.filter((group) => !group.hidden).map((group) => (
      <React.Fragment key={group.key}>
        <div className="ntype-preview-group">{group.label || labels.groups[group.key]}</div>
        {group.items.filter((item) => !item.hidden).map((item) => (
          <div key={item.key} className="ntype-preview-item">{itemLabel(item, labels, contactLabel)}</div>
        ))}
      </React.Fragment>
    ))}
    <p className="ntype-preview-note">Shows every item. Real users only see the items their package and permissions allow.</p>
  </div>
);

NavPreview.propTypes = {
  layout: PropTypes.arrayOf(PropTypes.object).isRequired,
  registry: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  contactLabel: PropTypes.string.isRequired,
};

export default NavPreview;
